// extracted by mini-css-extract-plugin
export default {"option":"AvatarFields_option__VMnri","icon":"AvatarFields_icon__O1wes","field":"AvatarFields_field__TDX8f"};